// extracted by mini-css-extract-plugin
module.exports = {"form":"ShippingFormRenderer_form__bEL_s","cardContent":"ShippingFormRenderer_cardContent__noIJw"};